const VideoChatConnectionError = {
  unknown: 'unknown',
};

export default VideoChatConnectionError;
